import { DataDisplayEvent, Textbox } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutOrderPayablesOrderIdQuickInfo } from "./autogen/AutogenLayoutOrderPayablesOrderIdQuickInfo";

export class OrderPayablesOrderIdQuickInfo extends AutogenLayoutOrderPayablesOrderIdQuickInfo {

    textboxMovementIdOnDataDisplay(event: DataDisplayEvent) {
        this.textboxMovementId.printableLabel.link = LayoutUrl.create(
            "lme/dispatch/OrderTabView",
            {
                mode: "update",
                key: event.rowData?.get("id"),
                orderId: event.rowData?.get("orders.id")
            }
        );
    }

    textboxOrderIdOnDataDisplay(event: DataDisplayEvent) {
        this.textboxOrderId.printableLabel.link = LayoutUrl.createForUpdateMode(
            "lme/dispatch/OrderTabView",
            event.rowData?.get("orders.id")
        );
    }
}
